export const groupBy = (collection, iteratee) => {
  const list = Array.isArray(collection) ? collection : Object.values(collection);

  return list.reduce((groupped, item) => {
    let groupKey;

    if (typeof iteratee === 'function') {
      groupKey = iteratee(item);
    } else {
      groupKey = item[iteratee];
    }

    if (groupKey) {
      if (!groupped[groupKey]) groupped[groupKey] = [];

      groupped[groupKey].push(item);
    }

    return groupped;
  }, {});
};
